import styled from 'styled-components';

export const StyledEmptyPageLoaderContainer = styled.div`
    height: 100%;
    width: 100%;
    max-height: 100vh;
    max-width: 100vw;
    background-color: transparent;
    display: flex;
    justify-content: center;
    box-sizing: border-box;
`;

export const StyledEmptyPageLoaderContent = styled.div`
    box-sizing: border-box;
    padding-top: 90px;
    text-align: center;
    display: flex;
    flex-direction: column;
`;
